import { Component, OnInit, Output, EventEmitter, Inject, OnDestroy } from '@angular/core';
import { Store } from '@ngrx/store';

import { SupportInfo } from '../_interfaces_/support-info.interface';
import { DeviceDetectorService } from 'ngx-device-detector';
import { LocalStorageService } from '@shared/services/local-storage/local-storage.service';
import { AppState } from '@store/state';
import { selectSelectedAffiliateCode } from '@store/session/session.selectors';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { AuthConfigLoaderService } from '@shared/services/auth-config-loader/auth-config-loader.service';

@Component({
  selector: 'app-support-info',
  templateUrl: './support-info.component.html',
  styleUrls: ['./support-info.component.scss'],
})
export class SupportInfoComponent implements OnInit, OnDestroy {
  // tslint:disable-next-line: no-output-native
  @Output() close = new EventEmitter<void>(); // TODO
  supportInfo: SupportInfo;
  private unsubscribeAll$: Subject<void> = new Subject();

  constructor(
    @Inject(DeviceDetectorService) private _deviceService: DeviceDetectorService,
    @Inject(Store) private _store: Store<AppState>,
    @Inject(LocalStorageService) private _localStorageService: LocalStorageService,
    @Inject(AuthConfigLoaderService) private _authConfigLoaderService: AuthConfigLoaderService
  ) {}

  ngOnInit(): void {
    this.setSupportInfo();
  }

  setSupportInfo(): void {
    this.supportInfo = {
      affiliateCode: this._authConfigLoaderService.getSessionClientId(),
      sessionId: this._localStorageService.getUserSessionToken(),
      browser: this._deviceService.browser,
      version: this._deviceService.browser_version,
      os: this._deviceService.os,
    };
  }

  ngOnDestroy(): void {
    this.unsubscribeAll$.next();
    this.unsubscribeAll$.complete();
  }
}
